<script setup lang="ts">
import { CommandPaletteOrderSearchDocument } from '~/graphql/operations'
import { ComboboxOption } from '@headlessui/vue'

const router = useRouter()

const props = defineProps<{
  query: string
}>()

const orderSearchQuery = useQuery({
  query: CommandPaletteOrderSearchDocument,
  variables: computed(() => ({ orderNumber: props.query })),
  pause: true,
})

const searchResults = computed(() => {
  return (
    orderSearchQuery.data.value?.ordersNumber.map((order: any) => ({
      id: `order-search-${order.id}`,
      name: `Order #${order.orderNumber}`,
      description: `Navigate to order details`,
      icon: 'i-icon-park-outline:weixin-market',
      action: () => router.push(`/orders/${order.id}`),
    })) || []
  )
})
let debouncer = null
const debounceInProgress = ref(false)
watch(
  () => props.query,
  () => {
    if (debouncer) {
      clearTimeout(debouncer)
    }
    debounceInProgress.value = true
    debouncer = setTimeout(() => {
      debounceInProgress.value = false
      orderSearchQuery.executeQuery()
    }, 300)
  },
  {
    immediate: true,
  }
)

const isLoading = computed(() => orderSearchQuery.fetching.value || debounceInProgress.value)
const items = computed(() => {
  if (isLoading.value) return []
  if (!props.query.length) return []
  return searchResults.value
})


</script>
<template>
  <LoadingBar v-if="isLoading" class="text-primary w-full" />
  <div
    class="px-4 py-4 bg-gray-50 text-xs font-medium text-gray-500 uppercase d"
    :class="{
      'pt-3': isLoading,
      'pt-4': !isLoading,
    }"
  >
    Orders
  </div>

  <ComboboxOption
    v-if="items.length"
    v-for="item in items"
    :key="item.id"
    :value="item"
    v-slot="{ active }"
    as="template"
  >
    <CommandPaletteItem :item="item" :active="active" />
  </ComboboxOption>
  <CommandPaletteMessagesSearching v-else-if="isLoading && !items.length" />
  <CommandPaletteMessagesNothingFound v-else-if="query.length" />
  <div v-else-if="!query.length" class="py-8 px-6 text-center text-sm">
    <p class="mt-2 text-gray-500">
      Search for orders by entering the order number, e.g. "order 123456"
    </p>
  </div>
</template>
